import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import { string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import OrdinanceCard from './OrdinanceCard'
import OrdinanceParser from '../../../../../helpers/ordinance/OrdinanceParser'
import { useOrdinances } from '../../../../../../wcf/global/hooks'

const titleCss = css`
  font-family: museo, sans-serif;
  font-size: 35px;
`
const ordinanceCss = css`
  margin: 10px 0px;
`
const ordinancesWrapper = css`
  margin-left: 8vw;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
`

const Complete = ({ ordinances, t }) => (
  <div css={ordinanceCss}>
    <h1 css={titleCss}>{t('wcf.person-ordinances.ordinances', 'Ordinances')}</h1>
    {ordinances.map((ordinance) => (
      <OrdinanceCard key={ordinance.key} ord={ordinance} />
    ))}
  </div>
)

export default function PersonOrdinances({ personId }) {
  const [ordinances, setOrdinances] = React.useState([])

  const [ordinancesData] = useOrdinances({ personId })
  const { t } = useTranslation()

  useEffect(() => {
    if (ordinancesData) {
      const parser = new OrdinanceParser({ data: ordinancesData, t })
      const allData = parser.buildOrdinanceList()
      setOrdinances(allData)
    }
  }, [ordinancesData, personId, t])

  return (
    <div css={ordinancesWrapper}>
      <Complete ordinances={ordinances} t={t} />
    </div>
  )
}

PersonOrdinances.propTypes = {
  personId: string,
}
